import countries from '@/config/i18n-iso-countries.config';

export const countryName = (iso3: string): string =>
  countries.getName(iso3, 'fr') ?? iso3;

export const GENDER_LABELS: Record<string, string> = {
  MALE: 'Hommes',
  FEMALE: 'Femmes',
};

export const RELIGION_LABELS: Record<string, string> = {
  CATHOLIC: 'Catholique',
  PROTESTANT: 'Protestant(e)',
  ISLAM: 'Islam',
  HINDU: 'Hindou(e)',
  ATHEIST: 'Athée',
  CHRISTIAN: 'Chrétien(ne)',
  PENTECOSTAL: 'Pentecôtiste',
  NO_ANSWER: 'Non précisé',
};
